import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mall-store" }
const _hoisted_2 = { class: "mall-store__shell" }
const _hoisted_3 = {
  key: 0,
  class: "mall-store__empty"
}
const _hoisted_4 = {
  key: 1,
  class: "mall-store__empty"
}
const _hoisted_5 = { class: "mall-store__head" }
const _hoisted_6 = { class: "mall-store__crumb" }
const _hoisted_7 = { class: "mall-store__meta" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 0,
  class: "mall-store__policy"
}
const _hoisted_12 = { class: "mall-store__toolbar" }
const _hoisted_13 = {
  key: 0,
  class: "mall-store__grid"
}
const _hoisted_14 = {
  key: 1,
  class: "mall-store__empty-inline"
}

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import ProductCard from '@/components/mall/ProductCard.vue'
import { fetchMallStore, toMallProduct, type MallPublicStore } from '@/api/mallProduct'
import { MALL_HOME_PATH } from '@/constants/mall'
import { type MallProduct } from '@/constants/mallProducts'
import { summarizeProductShippingFees } from '@/utils/mallShipping'
import { useSameDayCutoffText } from '@/composables/useContentSnippets'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallStorePage',
  setup(__props) {

const route = useRoute()
const loading = ref(true)
const store = ref<MallPublicStore | null>(null)
const products = ref<MallProduct[]>([])
const { sameDayCutoffText, loadSameDayCutoffSnippet } = useSameDayCutoffText(
  () => store.value?.cutoff,
)

/** 고객에게는 스토어 기본값이 아니라 실제 판매 상품 배송비를 보여 준다. */
const shippingLabel = computed(() =>
  summarizeProductShippingFees(products.value.map((product) => product.shippingFee)),
)

const returnFeeLabel = computed(() => (store.value ? '반품 배송비는 상품마다 다릅니다' : ''))

async function load() {
  loading.value = true
  store.value = null
  products.value = []

  try {
    const data = await fetchMallStore(String(route.params.code || ''))
    store.value = data.store
    products.value = data.products.map(toMallProduct)
  } catch {
    store.value = null
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  void loadSameDayCutoffSnippet()
  void load()
})
watch(
  () => route.params.code,
  () => {
    load()
  },
)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(AppIcon, {
              icon: "mdi-loading",
              size: 40
            }),
            _cache[0] || (_cache[0] = _createElementVNode("p", null, "스토어를 불러오는 중입니다…", -1))
          ]))
        : (!store.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(AppIcon, {
                icon: "mdi-store-off-outline",
                size: 56
              }),
              _cache[2] || (_cache[2] = _createElementVNode("p", null, "판매업체를 찾을 수 없습니다.", -1)),
              _createVNode(_component_router_link, { to: _unref(MALL_HOME_PATH) }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("함우리몰 홈으로", -1)
                ]))]),
                _: 1
              }, 8, ["to"])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("header", _hoisted_5, [
                _createElementVNode("nav", _hoisted_6, [
                  _createVNode(_component_router_link, { to: _unref(MALL_HOME_PATH) }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("함우리몰", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(AppIcon, {
                    icon: "mdi-chevron-right",
                    size: 16
                  }),
                  _cache[4] || (_cache[4] = _createElementVNode("span", null, "판매업체", -1))
                ]),
                _createElementVNode("h1", null, _toDisplayString(store.value.storeName), 1),
                _createElementVNode("p", _hoisted_7, [
                  (shippingLabel.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(shippingLabel.value), 1))
                    : _createCommentVNode("", true),
                  (_unref(sameDayCutoffText))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(sameDayCutoffText)), 1))
                    : _createCommentVNode("", true),
                  (returnFeeLabel.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(returnFeeLabel.value), 1))
                    : _createCommentVNode("", true)
                ]),
                (store.value.returnPolicy)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(store.value.returnPolicy), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", null, _toDisplayString(products.value.length) + "개 상품", 1)
              ]),
              (products.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product) => {
                      return (_openBlock(), _createBlock(ProductCard, {
                        key: product.id,
                        product: product
                      }, null, 8, ["product"]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_14, "등록된 판매 상품이 없습니다."))
            ], 64))
    ])
  ]))
}
}

})